import { render } from "./CourseListingComponent.vue?vue&type=template&id=db5e47c6&scoped=true"
import script from "./CourseListingComponent.vue?vue&type=script&lang=js"
export * from "./CourseListingComponent.vue?vue&type=script&lang=js"

import "./CourseListingComponent.vue?vue&type=style&index=0&id=db5e47c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db5e47c6"]])

export default __exports__